const baseStyle = (props: any) => {
  const { secondary, error } = props.theme.colors;

  return {
    backgroundColor: 'white',
    borderRadius: 4,
    fontFamily: 'body',
    fontSize: 'md',
    height: '40px',
    overflow: 'visible',
    px: '12px',
    py: '0',
    _disabled: {
      bgColor: 'gray.50',
      borderColor: 'gray.500',
      color: 'gray.500',
      opacity: '1',
      _web: {
        disabled: true,
        cursor: 'not-allowed',
      },
    },
    _web: {
      outlineWidth: '0',
      overflow: 'auto',
      lineHeight: 'md',
      style: { outline: 'none' },
      cursor: 'auto',
    },
    _input: {
      bgColor: 'transparent',
      flex: 1,
      w: '100%',
      h: '100%',
    },
    _light: {
      borderColor: 'gray.600',
      color: 'gray.900',
      placeholderTextColor: 'gray.600',
      _hover: {
        bgColor: 'secondary.50',
        borderColor: 'secondary.500',
      },
      _focus: {
        bgColor: 'white',
        borderColor: 'gray.300',
        _hover: {
          bgColor: 'white',
          borderColor: 'gray.300',
        },
        _stack: {
          style: {
            boxShadow: `0px 0px 0px 3px ${secondary[400]}`,
            outlineWidth: '1px',
            outlineColor: 'white',
            outlineStyle: 'solid',
            borderColor: `${secondary[400]}`,
            shadowColor: `${secondary[400]}`,
            shadowOffset: {
              height: 0,
              width: 0,
            },
            shadowOpacity: 0.5,
          },
        },
      },
      _invalid: {
        borderColor: 'error.500',
        _hover: {
          bgColor: 'error.50',
          borderColor: 'error.500',
        },
        _focus: {
          bgColor: 'white',
          borderColor: 'gray.300',
          _hover: {
            bgColor: 'white',
            borderColor: 'gray.300',
          },
          _stack: {
            style: {
              boxShadow: `0px 0px 0px 3px ${error[500]}`,
              outlineWidth: '1px',
              outlineColor: 'white',
              outlineStyle: 'solid',
            },
          },
        },
        _stack: {
          style: {
            outlineWidth: '0',
          },
        },
      },
      _ios: {
        selectionColor: 'blue.400',
      },
      _android: {
        selectionColor: 'blue.400',
      },
      _disabled: {
        placeholderTextColor: 'gray.500',
        _hover: {
          borderColor: 'gray.500',
        },
      },
      _stack: {
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',
      },
    },
    _dark: {
      borderColor: 'gray.600',
      color: 'gray.900',
      placeholderTextColor: 'gray.600',
      _hover: {
        bgColor: 'secondary.50',
        borderColor: 'secondary.500',
      },
      _focus: {
        bgColor: 'white',
        borderColor: 'gray.300',
        _hover: {
          bgColor: 'white',
          borderColor: 'gray.300',
        },
        _stack: {
          style: {
            boxShadow: `0px 0px 0px 3px ${secondary[500]}`,
            outlineWidth: '1px',
            outlineColor: 'white',
            outlineStyle: 'solid',
          },
        },
      },
      _invalid: {
        borderColor: 'error.500',
        _hover: {
          bgColor: 'error.50',
          borderColor: 'error.500',
        },
        _focus: {
          bgColor: 'white',
          borderColor: 'gray.300',
          _hover: {
            bgColor: 'white',
            borderColor: 'gray.300',
          },
          _stack: {
            style: {
              boxShadow: `0px 0px 0px 3px ${error[500]}`,
              outlineWidth: '1px',
              outlineColor: 'white',
              outlineStyle: 'solid',
            },
          },
        },
        _stack: {
          style: {
            outlineWidth: '0',
          },
        },
      },
      _ios: {
        selectionColor: 'blue.400',
      },
      _android: {
        selectionColor: 'blue.400',
      },
      _disabled: {
        placeholderTextColor: 'gray.500',
        _hover: {
          borderColor: 'gray.500',
        },
      },
      _stack: {
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',
      },
    },
  };
};

function roundedStyle() {
  return {
    borderRadius: 'full',
    borderWidth: '1',
  };
}

function outlineStyle() {
  return {
    borderWidth: '1',
  };
}

function filledStyle() {
  return {
    borderWidth: '1',
    _hover: {
      borderWidth: '1',
      _disabled: {
        borderWidth: 0,
      },
    },
    _light: {
      bgColor: 'muted.100',
      borderColor: 'muted.100',
    },
    _dark: {
      bgColor: 'muted.100',
      borderColor: 'muted.100',
    },
  };
}

function unstyledStyle() {
  return {
    borderWidth: '0',
    _focus: {
      bgColor: 'transparent',
    },
    _invalid: {
      _stack: {
        style: {
          outlineWidth: 0,
        },
      },
    },
    _stack: {
      _focus: {
        style: {
          outlineWidth: '0',
        },
      },
    },
  };
}

function underlinedStyle(props: Record<string, any>) {
  const { secondary, error } = props.theme.colors;

  return {
    borderWidth: '0',
    pl: '0',
    borderBottomWidth: '1',
    _light: {
      _focus: {
        _stack: {
          style: {
            outlineWidth: '0',
            boxShadow: `0 1px 0 0 ${props.focusOutlineColor || secondary[600]}`,
          },
        },
      },
      _invalid: {
        _stack: {
          style: {
            outlineWidth: 0,
            boxShadow: `0 1px 0 0 ${props.inValidOutlineColor || error[600]}`,
          },
        },
      },
    },
    _dark: {
      _focus: {
        _stack: {
          style: {
            outlineWidth: '0',
            boxShadow: `0 1px 0 0 ${props.focusOutlineColor || secondary[600]}`,
          },
        },
      },
      _invalid: {
        _stack: {
          style: {
            outlineWidth: 0,
            boxShadow: `0 1px 0 0 ${props.inValidOutlineColor || error[600]}`,
          },
        },
      },
    },
    borderRadius: 0,
  };
}

const variants = {
  outline: outlineStyle,
  underlined: underlinedStyle,
  rounded: roundedStyle,
  filled: filledStyle,
  unstyled: unstyledStyle,
};

const sizes = {
  '2xl': { fontSize: 'md' },
  'xl': { fontSize: 'md' },
  'lg': { fontSize: 'md' },
  'md': { fontSize: 'md' },
  'sm': { fontSize: 'md' },
  'xs': { fontSize: 'md' },
};

const defaultProps = {
  size: 'sm',
  variant: 'outline',
};

// Input
export const Input = {
  baseStyle,
  defaultProps,
  variants,
  sizes,
};

export default {};
